





























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Clickbutton from "@/components/Clickbutton.vue";
import ProcessFlowState from "@/components/ProcessFlowState.vue";
import TranslationsCompletion from "@/components/TranslationsCompletion.vue";

@Component(
{
	components: {
		Clickbutton,
		ProcessFlowState,
		TranslationsCompletion
	}
})

export default class TranslationsWidgetRow extends Vue
{
	@Prop() widgetId!: string;
	@Prop() widgetName!: string;
	@Prop() widgetDescription!: string;
	@Prop() translationCompletion!: number;

	data()
	{
		return {
			model: {
				translationCompletion: this.translationCompletion
			}
		}
	}

	onClick()
	{
		this.$router.push({ name: "item", query: { id: (this as any).widgetId }});
	}
}
